import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 1440px;
  min-width: 0;
  width: 100%;
  padding: 80px 70px 70px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  font-family: 'General Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  background: var(--color-page);
  min-height: 100vh;

  @media (max-width: 767px) {
    padding: 24px 16px;
  }

  main {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 60px 0 80px;
  }

  html[data-theme='dark'] & {
    background: var(--color-page);
  }
`;
